export const vehiculos = [
  {
    marca: "VOLKSWAGEN",
    modelos: [
      {
        nombre: "POLO - 1.6 TRENDLINE MSI",
        planes: [
          {
            nombre: "Plan 80/20",
            precios: [
              {
                mes: "febrero",
                monto: 2866400,
              },
              {
                mes: "marzo",
                monto: 2502350,
              },
              {
                mes: "abril",
                monto: 2614950,
              },
              {
                mes: "mayo",
                monto: 2762700,
              },
              {
                mes: "junio",
                monto: 2960500,
              },
              {
                mes: "julio",
                monto: 3201450,
              },
              {
                mes: "agosto",
                monto: 3377550,
              },
              {
                mes: "septiembre",
                monto: 3499150,
              },
              {
                mes: "octubre",
                monto: 3499150,
              },
            ],
          },
        ],
      },
      {
        nombre: "SAVEIRO 1.6 CABINA SIMPLE TREDLINE - MY21",
        planes: [
          {
            nombre: "Plan 80/20",
            precios: [
              {
                mes: "febrero",
                monto: 2643000,
              },
              {
                mes: "marzo",
                monto: 2771450,
              },
              {
                mes: "abril",
                monto: 2881750,
              },
              {
                mes: "mayo",
                monto: 2997000,
              },
              {
                mes: "junio",
                monto: 3129450,
              },
              {
                mes: "julio",
                monto: 3384100,
              },
              {
                mes: "agosto",
                monto: 3570250,
              },
              {
                mes: "septiembre",
                monto: 3933500,
              },
              {
                mes: "octubre",
                monto: 4169500,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    marca: "FIAT",
    modelos: [
      {
        nombre: "CRONOS DRIVE - 1.3 GSE PACK CONECTIVIDAD",
        planes: [
          {
            nombre: "Plan 80/10 ",
            precios: [
              {
                mes: "febrero",
                monto: 2365200,
              },
              {
                mes: "marzo",
                monto: 2475200,
              },
              {
                mes: "abril",
                monto: 2599000,
              },
              {
                mes: "mayo",
                monto: 2824700,
              },
              {
                mes: "junio",
                monto: 2824700,
              },
              {
                mes: "julio",
                monto: 3202000,
              },
              {
                mes: "agosto",
                monto: 3371800,
              },
              {
                mes: "septiembre",
                monto: 3473000,
              },
              {
                mes: "octubre",
                monto: 3473000,
              },
            ],
          },
          {
            nombre: "Plan 90/10",
            precios: [
              {
                mes: "febrero",
                monto: 2365200,
              },
              {
                mes: "marzo",
                monto: 2475200,
              },
              {
                mes: "abril",
                monto: 2599000,
              },
              {
                mes: "mayo",
                monto: 2824700,
              },
              {
                mes: "junio",
                monto: 2824700,
              },
              {
                mes: "julio",
                monto: 3202000,
              },
              {
                mes: "agosto",
                monto: 3371800,
              },
              {
                mes: "septiembre",
                monto: 3473000,
              },
              {
                mes: "octubre",
                monto: 3473000,
              },
            ],
          },
        ],
      },
      {
        nombre: "TORO FREEDOM 1.8 AT6 (NAFTA)",
        planes: [
          {
            nombre: "Plan 70/30",
            precios: [
              {
                mes: "febrero",
                monto: 3806800,
              },
              {
                mes: "marzo",
                monto: 3806800,
              },
              {
                mes: "abril",
                monto: 4185100,
              },
              {
                mes: "mayo",
                monto: 4680300,
              },
              {
                mes: "junio",
                monto: 4961200,
              },
              {
                mes: "julio",
                monto: 5283700,
              },
              {
                mes: "agosto",
                monto: 5653600,
              },
              {
                mes: "septiembre",
                monto: 5879800,
              },
              {
                mes: "octubre",
                monto: 5879800,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    marca: "RENAULT",
    modelos: [
      {
        nombre: "SANDERO LIFE 1.6",
        planes: [
          {
            nombre: "Plan 75%",
            precios: [
              {
                mes: "febrero",
                monto: 2418500,
              },
              {
                mes: "marzo",
                monto: 2527300,
              },
              {
                mes: "abril",
                monto: 2641000,
              },
              {
                mes: "mayo",
                monto: 2773100,
              },
              {
                mes: "junio",
                monto: 2773100,
              },
              {
                mes: "julio",
                monto: 3086500,
              },
              {
                mes: "agosto",
                monto: 3256300,
              },
              {
                mes: "septiembre",
                monto: 3321400,
              },
              {
                mes: "octubre",
                monto: 3404400,
              },
            ],
          },
          {
            nombre: "Plan 100%",
            precios: [
              {
                mes: "febrero",
                monto: 2418500,
              },
              {
                mes: "marzo",
                monto: 2527300,
              },
              {
                mes: "abril",
                monto: 2641000,
              },
              {
                mes: "mayo",
                monto: 2773100,
              },
              {
                mes: "junio",
                monto: 2773100,
              },
              {
                mes: "julio",
                monto: 3086500,
              },
              {
                mes: "agosto",
                monto: 3256300,
              },
              {
                mes: "septiembre",
                monto: 3321400,
              },
              {
                mes: "octubre",
                monto: 3404400,
              },
            ],
          },
        ],
      },
      {
        nombre: "DUSTER ZEN 1.6",
        planes: [
          {
            nombre: "Plan 100%",
            precios: [
              {
                mes: "febrero",
                monto: 3359900,
              },
              {
                mes: "marzo",
                monto: 3527900,
              },
              {
                mes: "abril",
                monto: 3704300,
              },
              {
                mes: "mayo",
                monto: 3726100,
              },
              {
                mes: "junio",
                monto: 3726100,
              },
              {
                mes: "julio",
                monto: 4240300,
              },
              {
                mes: "agosto",
                monto: 4240300,
              },
              {
                mes: "septiembre",
                monto: 4664300,
              },
              {
                mes: "octubre",
                monto: 4664300,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    marca: "FORD",
    modelos: [
      {
        nombre: "NUEVA RANGER XL",
        planes: [
          {
            nombre: "Plan 80/20",
            precios: [
              {
                mes: "febrero",
                monto: 4848960,
              },
              {
                mes: "marzo",
                monto: 4753000,
              },
              {
                mes: "abril",
                monto: 4763520,
              },
              {
                mes: "mayo",
                monto: 5027000,
              },
              {
                mes: "junio",
                monto: 5027000,
              },
              {
                mes: "julio",
                monto: 5557440,
              },
              {
                mes: "agosto",
                monto: 5732520,
              },
              {
                mes: "septiembre",
                monto: 6606000,
              },
              {
                mes: "octubre",
                monto: 6229200,
              },
            ],
          },
        ],
      },
      {
        nombre: "TERRITORY SEL",
        planes: [
          {
            nombre: "Plan 80/20",
            precios: [
              {
                mes: "febrero",
                monto: 5517372,
              },
              {
                mes: "marzo",
                monto: 5996760,
              },
              {
                mes: "abril",
                monto: 5996760,
              },
              {
                mes: "mayo",
                monto: 5890000,
              },
              {
                mes: "junio",
                monto: 5890000,
              },
              {
                mes: "julio",
                monto: 6548724,
              },
              {
                mes: "agosto",
                monto: 7073052,
              },
              {
                mes: "septiembre",
                monto: 8155000,
              },
              {
                mes: "octubre",
                monto: 7687008,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    marca: "CITROEN",
    modelos: [
      {
        nombre: "BERLINGO FURGON VTI 115 BUSINESS",
        planes: [
          {
            nombre: "Plan 80/20",
            precios: [
              {
                mes: "febrero",
                monto: 2957752,
              },
              {
                mes: "marzo",
                monto: 3183000,
              },
              {
                mes: "abril",
                monto: 2957752,
              },
              {
                mes: "mayo",
                monto: 4150000,
              },
              {
                mes: "junio",
                monto: 3920574,
              },
              {
                mes: "julio",
                monto: 3920574,
              },
              {
                mes: "agosto",
                monto: 4195008,
              },
              {
                mes: "septiembre",
                monto: 4320835,
              },
              {
                mes: "octubre",
                monto: 4596480,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    marca: "PEUGEOT",
    modelos: [
      {
        nombre: "208 LIKE 1.2 L",
        planes: [
          {
            nombre: "Plan 80/20",
            precios: [
              {
                mes: "febrero",
                monto: 3033413,
              },
              {
                mes: "marzo",
                monto: 3169863,
              },
              {
                mes: "abril",
                monto: 3033413,
              },
              {
                mes: "mayo",
                monto: 3107200,
              },
              {
                mes: "junio",
                monto: 3107200,
              },
              {
                mes: "julio",
                monto: 3107200,
              },
              {
                mes: "agosto",
                monto: 3107200,
              },
              {
                mes: "septiembre",
                monto: 3627400,
              },
              {
                mes: "octubre",
                monto: 4410071,
              },
            ],
          },
        ],
      },
      {
        nombre: "PARTNER CONFORT 1.6",
        planes: [
          {
            nombre: "Plan 80/20",
            precios: [
              {
                mes: "febrero",
                monto: 2957752,
              },
              {
                mes: "marzo",
                monto: 3105652,
              },
              {
                mes: "abril",
                monto: 2957752,
              },
              {
                mes: "mayo",
                monto: 2928500,
              },
              {
                mes: "junio",
                monto: 2928500,
              },
              {
                mes: "julio",
                monto: 2928500,
              },
              {
                mes: "agosto",
                monto: 2928500,
              },
              {
                mes: "septiembre",
                monto: 3554000,
              },
              {
                mes: "octubre",
                monto: 4320835,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    marca: "TOYOTA",
    modelos: [
      {
        nombre: "YARIS XS",
        planes: [
          {
            nombre: "Plan 70%",
            precios: [
              {
                mes: "febrero",
                monto: 3581500,
              },
              {
                mes: "marzo",
                monto: 3656900,
              },
              {
                mes: "abril",
                monto: 3729700,
              },
              {
                mes: "mayo",
                monto: 3811600,
              },
              {
                mes: "junio",
                monto: 3811600,
              },
              {
                mes: "julio",
                monto: 4202900,
              },
              {
                mes: "agosto",
                monto: 4413500,
              },
              {
                mes: "septiembre",
                monto: 4656600,
              },
              {
                mes: "octubre",
                monto: 4936100,
              },
            ],
          },
          {
            nombre: "Plan 100%",
            precios: [
              {
                mes: "febrero",
                monto: 2755000,
              },
              {
                mes: "marzo",
                monto: 2813000,
              },
              {
                mes: "abril",
                monto: 2869000,
              },
              {
                mes: "mayo",
                monto: 2932000,
              },
              {
                mes: "junio",
                monto: 2932000,
              },
              {
                mes: "julio",
                monto: 3233000,
              },
              {
                mes: "agosto",
                monto: 3395000,
              },
              {
                mes: "septiembre",
                monto: 3582000,
              },
              {
                mes: "octubre",
                monto: 3797000,
              },
            ],
          },
        ],
      },
      {
        nombre: "COROLLA XLI MT",
        planes: [
          {
            nombre: "Plan 100%",
            precios: [
              {
                mes: "febrero",
                monto: 3303000,
              },
              {
                mes: "marzo",
                monto: 3458000,
              },
              {
                mes: "abril",
                monto: 3596000,
              },
              {
                mes: "mayo",
                monto: 3770000,
              },
              {
                mes: "junio",
                monto: 3770000,
              },
              {
                mes: "julio",
                monto: 4155000,
              },
              {
                mes: "agosto",
                monto: 4155000,
              },
              {
                mes: "septiembre",
                monto: 4528000,
              },
              {
                mes: "octubre",
                monto: 4773000,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    marca: "NISSAN",
    modelos: [
      {
        nombre: "NUEVO VERSA",
        planes: [
          {
            nombre: "Plan 80/20",
            precios: [
              {
                mes: "febrero",
                monto: 2542100,
              },
              {
                mes: "marzo",
                monto: 2643800,
              },
              {
                mes: "abril",
                monto: 2763000,
              },
              {
                mes: "mayo",
                monto: 2887300,
              },
              {
                mes: "junio",
                monto: 2887300,
              },
              {
                mes: "julio",
                monto: 3149000,
              },
              {
                mes: "agosto",
                monto: 3306500,
              },
              {
                mes: "septiembre",
                monto: 3405700,
              },
              {
                mes: "octubre",
                monto: 4069700,
              },
            ],
          },
        ],
      },
      {
        nombre: "NUEVO KICKS",
        planes: [
          {
            nombre: "Plan 70/30",
            precios: [
              {
                mes: "febrero",
                monto: 3224800,
              },
              {
                mes: "marzo",
                monto: 3386000,
              },
              {
                mes: "abril",
                monto: 3521400,
              },
              {
                mes: "mayo",
                monto: 3627000,
              },
              {
                mes: "junio",
                monto: 3627000,
              },
              {
                mes: "julio",
                monto: 3960700,
              },
              {
                mes: "agosto",
                monto: 4147200,
              },
              {
                mes: "septiembre",
                monto: 4230100,
              },
              {
                mes: "octubre",
                monto: 4526200,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    marca: "CHEVROLET",
    modelos: [
      {
        nombre: "JOY PLUS",
        planes: [
          {
            nombre: "Plan 100%",
            precios: [
              {
                mes: "febrero",
                monto: 2337900,
              },
              {
                mes: "marzo",
                monto: 2481900,
              },
              {
                mes: "abril",
                monto: 2630900,
              },
              {
                mes: "mayo",
                monto: 2801900,
              },
              {
                mes: "junio",
                monto: 2801900,
              },
              {
                mes: "julio",
                monto: 3089900,
              },
              {
                mes: "agosto",
                monto: 3290900,
              },
              {
                mes: "septiembre",
                monto: 3390900,
              },
              {
                mes: "octubre",
                monto: 3390900,
              },
            ],
          },
        ],
      },
      {
        nombre: "CRUZE 5",
        planes: [
          {
            nombre: "Plan 100%",
            precios: [
              {
                mes: "febrero",
                monto: 3431900,
              },
              {
                mes: "marzo",
                monto: 3586900,
              },
              {
                mes: "abril",
                monto: 3726900,
              },
              {
                mes: "mayo",
                monto: 3726900,
              },
              {
                mes: "junio",
                monto: 3726900,
              },
              {
                mes: "julio",
                monto: 4155900,
              },
              {
                mes: "agosto",
                monto: 4240900,
              },
              {
                mes: "septiembre",
                monto: 4369900,
              },
              {
                mes: "octubre",
                monto: 4369900,
              },
            ],
          },
        ],
      },
    ],
  },
];

export const actividades = [
  {
    nombre: "EMPLEADOS DE COMERCIO",
    sueldos: [
      {
        mes: "febrero",
        monto: 0,
      },
      {
        mes: "marzo",
        monto: 6,
      },
      {
        mes: "abril",
        monto: 6,
      },
      {
        mes: "mayo",
        monto: 6,
      },
      {
        mes: "junio",
        monto: 0,
      },
      {
        mes: "julio",
        monto: 25,
      },
      {
        mes: "agosto",
        monto: 10,
      },
      {
        mes: "septiembre",
        monto: 0,
      },
      {
        mes: "octubre",
        monto: 11,
      },
    ],
  },
  {
    nombre: "SUELDO MINIMO VITAL Y MOVIL",
    sueldos: [
      {
        mes: "febrero",
        monto: 0,
      },
      {
        mes: "marzo",
        monto: 18,
      },
      {
        mes: "abril",
        monto: 0,
      },
      {
        mes: "mayo",
        monto: 10,
      },
      {
        mes: "junio",
        monto: 0,
      },
      {
        mes: "julio",
        monto: 0,
      },
      {
        mes: "agosto",
        monto: 7,
      },
      {
        mes: "septiembre",
        monto: 7,
      },
      {
        mes: "octubre",
        monto: 7,
      },
    ],
  },
  {
    nombre: "EMPLEADOS DE LA ADMINISTRACION PUBLICA",
    sueldos: [
      {
        mes: "febrero",
        monto: 8,
      },
      {
        mes: "marzo",
        monto: 0,
      },
      {
        mes: "abril",
        monto: 0,
      },
      {
        mes: "mayo",
        monto: 8,
      },
      {
        mes: "junio",
        monto: 0,
      },
      {
        mes: "julio",
        monto: 16,
      },
      {
        mes: "agosto",
        monto: 0,
      },
      {
        mes: "septiembre",
        monto: 0,
      },
      {
        mes: "octubre",
        monto: 0,
      },
    ],
  },
  {
    nombre: "EMPLEADOS BANCARIOS",
    sueldos: [
      {
        mes: "febrero",
        monto: 0,
      },
      {
        mes: "marzo",
        monto: 34.1,
      },
      {
        mes: "abril",
        monto: 0,
      },
      {
        mes: "mayo",
        monto: 0,
      },
      {
        mes: "junio",
        monto: 51.1,
      },
      {
        mes: "julio",
        monto: 0,
      },
      {
        mes: "agosto",
        monto: 0,
      },
      {
        mes: "septiembre",
        monto: 60,
      },
      {
        mes: "octubre",
        monto: 0,
      },
    ],
  },
];

export const planesSelect = [
  {
    name: "100",
    value: 100,
  },
  {
    name: "80/20",
    value: 80,
  },
  {
    name: "70/30",
    value: 70,
  },
];

export const cuotasSelect = [84, 100, 120];
